<template>
  <!-- eslint-disable-next-line vue/no-unused-vars -->
  <router-view >
    <component :is="resolveComponent()" />
  </router-view>
</template>

<script>
import DownloadApp from './components/DownloadApp.vue';

export default {
  name: 'App',
  components: {
    DownloadApp,
  },
  methods: {
    resolveComponent() {
     return DownloadApp;
    },
  },
};
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>